module.exports = __webpack_public_path__ + "img/login-formbg.2b79863c.png";